import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse, GuidePricing, GuidePricingHistoryResponse } from '@/types';

export interface UpdateGuidePricingPayload {
  hourlyPrice: number;
  fullDayPrice: number;
  currency?: string;
}

export const guidePricingApi = {
  async getMine() {
    const response = await apiClient.get<ApiResponse<GuidePricing>>('/guide/pricing');
    return response.data.data!;
  },

  async update(payload: UpdateGuidePricingPayload) {
    const response = await apiClient.put<ApiResponse<GuidePricing>>('/guide/pricing', payload);
    return response.data.data!;
  },

  async getHistory(page = 1, limit = 10) {
    const response = await apiClient.get<ApiResponse<GuidePricingHistoryResponse>>(
      '/guide/pricing/history',
      { params: { page, limit } }
    );
    return response.data.data!;
  },

  async getByProfileId(profileId: string) {
    const response = await apiClient.get<ApiResponse<GuidePricing>>(
      `/guides/${profileId}/pricing`
    );
    return response.data.data!;
  },
};

export const guidePricingKeys = {
  all: ['guide-pricing'] as const,
  mine: () => [...guidePricingKeys.all, 'mine'] as const,
  history: (page: number, limit: number) =>
    [...guidePricingKeys.all, 'history', page, limit] as const,
  profile: (id: string) => [...guidePricingKeys.all, 'profile', id] as const,
};
